import { useEffect, useRef } from 'react';

import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';
import { useMapOrderToConfirmation } from '@/modules/perseo-billing/hooks';
import type { IOrder } from '@/modules/perseo-billing/interfaces/src/bff-web/billing/interfaces/orderV2';
import { setPaymentSuccess } from '@/modules/perseo-billing/store/slices/billing';

export const useSyncOrderToRedux = (order: IOrder | undefined) => {
  const dispatch = useAppDispatch();
  const hasDispatched = useRef(false);
  const currentPaymentSuccess = useAppSelector(
    (state) => state?.billing?.paymentSuccess
  );

  const { transformData } = useMapOrderToConfirmation();

  useEffect(() => {
    if (!order || hasDispatched.current) return;
    if (!dispatch) return;

    if (currentPaymentSuccess?.id === order.id) {
      hasDispatched.current = true;
      return;
    }

    const orderConfirmation = transformData(order);
    dispatch(setPaymentSuccess(orderConfirmation));
    hasDispatched.current = true;
  }, [order, dispatch, transformData, currentPaymentSuccess?.id]);
};

export default useSyncOrderToRedux;
